module.exports = __webpack_public_path__ + "static/media/noResults.045ed2bd.svg";